import React from 'react';
import { Link } from 'react-router-dom';
import ParticlesBG from '../Shared/ParticlesBG';
import '../Assets/Stylesheets/Pages/Discover.scss';

const Discover = () => {
  const categories = [
    {
      title: 'Paid Advertising',
      description: 'Boost your reach with targeted ads across multiple platforms',
      icon: '📢',
      link: '/paid-ads',
      color: '#FF6B6B'
    },
    {
      title: 'Social Media',
      description: 'Engage your audience with compelling social content',
      icon: '📱',
      link: '/socials',
      color: '#4ECDC4'
    },
    {
      title: 'Websites',
      description: 'Create stunning websites that convert visitors into customers',
      icon: '🌐',
      link: '/websites',
      color: '#45B7D1'
    },
    {
      title: 'Video Production',
      description: 'Tell your story with professional video content',
      icon: '🎥',
      link: '/videos',
      color: '#FFA07A'
    },
    {
      title: 'Press Releases',
      description: 'Get your news out with professional PR services',
      icon: '📰',
      link: '/pr',
      color: '#98D8C8'
    },
    {
      title: 'AI Marketing Tools',
      description: 'Leverage AI to create content and automate your marketing',
      icon: '🤖',
      link: '/ai-marketing-tools',
      color: '#FFCC00'
    }
  ];

  return (
    <div className="discover-page">
      <ParticlesBG />
      <div className="discover-hero">
        <div className="container">
          <h6>EXPLORE</h6>
          <h1>
            Discover <span className="gradient-text">Marketing Solutions</span>
          </h1>
          <p className="subtitle">
            Find the perfect marketing services to grow your business. 
            From digital ads to content creation, we've got you covered.
          </p>
        </div>
      </div>

      <div className="discover-content">
        <div className="container">
          <div className="categories-grid">
            {categories.map((category, index) => (
              <Link 
                to={category.link} 
                key={index} 
                className="category-card"
                style={{ '--card-color': category.color }}
              >
                <div className="category-icon">{category.icon}</div>
                <h3>{category.title}</h3>
                <p>{category.description}</p>
                <div className="category-arrow">→</div>
              </Link>
            ))}
          </div>

          <div className="cta-section">
            <h2>Need Help Choosing?</h2>
            <p>Our marketing experts can help you find the perfect solution for your business</p>
            <Link to="/contact" className="cta-button">
              Talk to an Expert
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discover;

